/* eslint-disable */
import { useQuery } from '@/Helpers';
import ProducedDetailComp from './ProducedDetailComp';
import DispatchedComp from './DispatchedComp';
import RestaurantDetailComp from './RestaurantDetailComp';
import IssuedDetailComp from './IssuedDetailComp';

function AiFmsDetailPage() {
	const query = useQuery();
	const mode = query.get('mode');
	const name = query.get('name');
	const id = query.get('id');
	const meal= query.get('meal');
	const rowIndex = query.get('rowIndex');
	const filters = JSON.parse(query.get('filters'));
	return (
		<>
			{mode === 'issued' && <IssuedDetailComp name={name} filters={filters} meal={meal} rowIndex={rowIndex} />}
			{mode === 'produced' && <ProducedDetailComp name={name} id={id} filters={filters} meal={meal} rowIndex={rowIndex} />}
			{mode === 'dispatched' && <DispatchedComp name={name} filters={filters} id={id} meal={meal} rowIndex={rowIndex} />}
			{mode === 'restaurantIndent' && <RestaurantDetailComp name={name} filters={filters} meal={meal} id={id} rowIndex={rowIndex} />}
		</>
	);
}
export default AiFmsDetailPage;
